














































































































import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'things-to-do',
  components: {},
})
export default class ThingsToDoPage extends Vue {}
